
export enum SubscriptionType {
    FreeTrial = 'FreeTrial',
    LifeTime = 'LifeTime',
    Standard = 'Standard'
}
